"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const store_1 = require("../../../store/store");
const DateSelector_1 = __importDefault(require("./DateSelector"));
const Confirm_1 = __importDefault(require("./Confirm"));
const TimeSelector_1 = __importDefault(require("./TimeSelector"));
const bookingSlice_1 = require("../../../store/slices/bookingSlice");
const dayjs_1 = __importDefault(require("dayjs"));
const lodash_1 = require("lodash");
const StepContainer = ({ appointment, bookingFlowType, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { currentStepIndex, currentBooking: { calendarId, date: { selectedDate, selectedTime }, }, } = (0, store_1.useAppSelector)((state) => state.booking);
    const steps = (0, react_1.useMemo)(() => [
        {
            title: __.trans('booking.step-choose-date'),
            component: (0, jsx_runtime_1.jsx)(DateSelector_1.default, { appointment: appointment, bookingFlowType: bookingFlowType }),
        },
        {
            title: __.trans('booking.step-choose-time'),
            component: (0, jsx_runtime_1.jsx)(TimeSelector_1.default, { appointment: appointment, bookingFlowType: bookingFlowType }),
        },
        {
            title: __.trans('booking.step-confirm-booking'),
            component: (0, jsx_runtime_1.jsx)(Confirm_1.default, { appointment: appointment, bookingFlowType: bookingFlowType }),
        },
    ], [appointment, bookingFlowType]);
    (0, react_1.useEffect)(() => {
        dispatch((0, bookingSlice_1.setStepIndex)(selectedTime ? 2 : selectedDate ? 1 : 0));
    }, [dispatch, selectedDate, selectedTime]);
    const handleStepClick = (index) => {
        if (index < currentStepIndex) {
            dispatch((0, bookingSlice_1.setStepIndex)(index));
            dispatch((0, bookingSlice_1.setSelectedDate)(undefined));
            dispatch((0, bookingSlice_1.setSelectedTime)(undefined));
            dispatch((0, bookingSlice_1.setCurrentCalendarMonth)((0, dayjs_1.default)().get('month')));
            dispatch((0, bookingSlice_1.setCurrentCalendarYear)((0, dayjs_1.default)().get('year')));
        }
    };
    return calendarId ? ((0, jsx_runtime_1.jsxs)("div", { className: "step-container rounded overflow-hidden shadow", children: [(0, jsx_runtime_1.jsx)("div", { className: "steps text-light", children: (0, lodash_1.map)(steps, (step, index) => ((0, jsx_runtime_1.jsx)("div", { role: "button", tabIndex: 0, className: (0, classnames_1.default)('step flex-grow-1 d-flex justify-content-center align-items-center py-2', { active: currentStepIndex >= index }), onClick: () => handleStepClick(index), onKeyDown: (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            handleStepClick(index);
                        }
                    }, children: `${index + 1}. ${step.title}` }, step.title))) }), (0, jsx_runtime_1.jsx)("div", { className: "component p-3", children: (0, lodash_1.get)(steps[currentStepIndex], 'component') })] })) : null;
};
exports.default = StepContainer;
